var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.user &&
    _vm.user.id &&
    !_vm.user.verified &&
    _vm.$route.name != 'verify-email' &&
    _vm.$route.name != 'verify-mobile'
  )?_c('v-system-bar',{staticClass:"verify-bar",attrs:{"fixed":"","app":"","transition":"slide-y-transition","color":"outline orange darken-4 white--text"}},[_c('v-layout',{on:{"click":_vm.handleClick}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-alert")]),_vm._v(" "+_vm._s(_vm.$lang("VerifyStatusText"))+" ")],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }